(async function () {
    async function loadingWait() {
        return await new Promise((resolve) => {
            var timerInterval = setInterval(function () {
                if (typeof app != "undefined") {
                    if (app._data.firstInstall == true) {
                        console.log("app._data.firstInstall");
                        clearInterval(timerInterval);
                        resolve();
                    }
                } else {
                    clearInterval(timerInterval);
                    resolve();
                }
                console.log("test----");
            }, 250);
        });
    }

    if (window.location.pathname == "/") {
        await loadingWait();
        console.log("---deneme----dasdas-");
        var spinner;
        var counterModal = 1;
        //var asapRenderCount = 0;

        window.modalInside = function () {
            dateAndTime();
            modalSteps(counterModal, null);
            if (counterModal == $("#pills-tab-pay li").length) {
                $(".pay-modal-next").hide();
                $(".pay-modal-complete").show();
            } else {
                $(".pay-modal-next").show();
                $(".pay-modal-complete").hide();
            }

            if ($(".delivery-options").val() == "collect") {
                $(".dodatepicker")
                    .closest("div")
                    .find("label")
                    .html(collect_value + " Date");
                $(".dotimepicker")
                    .closest("div")
                    .find("label")
                    .html(collect_value + " Time");
            } else if ($(".delivery-options").val() == "delivery") {
                $(".dodatepicker")
                    .closest("div")
                    .find("label")
                    .html(delivery_value + " Date");
                $(".dotimepicker")
                    .closest("div")
                    .find("label")
                    .html(delivery_value + " Time");

                if (!$("a.address").length) {
                    $("#pills-tab-pay li:nth-child(1) a").tab("show");
                    $("a.pay-tab-three")
                        .last()
                        .addClass("disabled")
                        .data("pass", 0);
                }
            }
        };

        $('a[data-toggle="pill"]').on("shown.bs.tab", function (e) {
            if ($(this).hasClass("pay-tab-one")) {
                $(this).attr("data-pass", 1);
                counterModal = 1;
                $(".pay-modal-next").show();
                $(".pay-modal-complete").hide();
                $(".pay-modal-previous").hide();
            }

            if ($(this).hasClass("pay-tab-two")) {
                $(".pay-modal-next").show();
                $(".pay-modal-previous").show();
                $(".pay-modal-complete").hide();
                counterModal = 2;
                $(this).attr("data-pass", 1);
                googleMaps();
            }

            if ($(this).hasClass("pay-tab-three")) {
                $(".pay-modal-next").hide();
                $(".pay-modal-previous").show();
                $(".pay-modal-complete").show();

                $(this).attr("data-pass", 1);
                counterModal = 3;
                if ($(".payment-type").val() == "card") {
                    $(".stripe-div").show();
                    $(".stripe-cash-div").hide();
                } else if ($(".payment-type").val() == "cash") {
                    $(".stripe-div").hide();
                    $(".stripe-cash-div").show();
                }
            }
        });

        $(document).on("click", ".pay-modal-next", () => {
            if (
                $(".pay-tab-two").hasClass("active") &&
                $("#selectMapDiv").is(":visible")
            ) {
                return;
            }
            if ($(".delivery-options").val() == "collect") {
                $(".pay-tab-two").addClass("disabled");
                counterModal++;
            } else {
                $(".pay-tab-two").removeClass("disabled");
            }
            modalSteps(counterModal, "next");
        });

        $(document).on("click", ".pay-modal-previous", () => {
            if ($(".delivery-options").val() == "collect") {
                counterModal--;
            }

            modalSteps(counterModal, "previous");
        });

        window.orderCompleteButton = function name(type) {
            if (type == "loading") {
                $(".pay-modal-complete").attr("disabled", true);
                $(".pay-modal-complete").html(spinner);
                $(".pay-modal-previous").hide();
                blockEl("#pay-modal-new div.modal-dialog");
                //$('.pay-modal-complete').addClass('disabled');
            } else {
                $(".pay-modal-complete").attr("disabled", false);
                $(".pay-modal-complete").html("COMPLETE");
                $(".pay-modal-previous").show();
                unBlockEl("#pay-modal-new div.modal-dialog");
                //$('.pay-modal-complete').removeClass('disabled');
            }
        };

        $(document).on("click", ".pay-modal-complete", () => {
            orderCompleteButton("loading");
            var dataForm = $(document).find(
                "select.r_data, input.r_data, textarea.r_data"
            );
            //bonusRender();
            postOrder(dataForm);
        });

        window.modalSteps = function (stepCount, steps) {
            if (steps == "next") {
                if (
                    stepCount >= 1 &&
                    stepCount < $("#pills-tab-pay li").length
                ) {
                    stepCount++;
                }
                $(
                    "#pills-tab-pay li:nth-child(" + stepCount + ") a"
                ).removeClass("disabled");
            }

            if (steps == "previous") {
                if (
                    stepCount > 1 &&
                    stepCount <= $("#pills-tab-pay li").length
                ) {
                    stepCount--;
                }
            }

            $("#pills-tab-pay li:nth-child(" + stepCount + ") a").tab("show");

            if (stepCount > 1) {
                $(".pay-modal-previous").show();
            } else {
                $(".pay-modal-previous").hide();
            }

            if (stepCount == 2) {
                if (!$('input[name="address"]').length) {
                    $("button.pay-modal-next")
                        .html("Please add an address")
                        .prop("disabled", true);
                } else {
                    $("button.pay-modal-next")
                        .html("NEXT->")
                        .prop("disabled", false);
                }
            } else {
                $("button.pay-modal-next")
                    .html("NEXT->")
                    .prop("disabled", false);
            }

            counterModal = stepCount;
        };

        $(document).on("change", ".delivery-options", (e) => {
            let delivery_type = $(
                "select.delivery-options option:selected"
            ).val();
            if (e.currentTarget.value == "collect") {
                $(".pay-tab-two").addClass("disabled");
            } else {
                $(".pay-tab-two").removeClass("disabled");
            }

            if (delivery_type == "delivery" || delivery_type == "collect") {
                requireDeliveryType(false);
                syncCartUpdate("payments/cart-edit", "route");
            } else {
                requireDeliveryType(true);
            }
        });

        if (auth) {
            var elements = stripe.elements();

            var style = {
                base: {
                    color: "#32325d",
                    fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
                    fontSmoothing: "antialiased",
                    fontSize: "16px",
                    "::placeholder": {
                        color: "#aab7c4",
                    },
                    lineHeight: "1.429",
                },
                invalid: {
                    color: "#fa755a",
                    iconColor: "#fa755a",
                },
            };
            var cardElement = elements.create("card", {
                hidePostalCode: true,
                style: style,
            });

            cardElement.mount("#card-element");

            cardElement.addEventListener("change", function (event) {
                var displayError = document.getElementById("card-errors");
                if (event.error) {
                    displayError.textContent = event.error.message;
                    $("div.actions ul li")
                        .last()
                        .find("a")
                        .prop("disabled", true);
                    $("#card-errors").addClass("alert alert-danger");
                } else {
                    displayError.textContent = "";
                    $("div.actions ul li")
                        .last()
                        .find("a")
                        .prop("disabled", false);
                    $("#card-errors").removeClass("alert alert-danger");
                }
            });
        }

        window.cAlertDlete = function (datai = undefined, datav = undefined) {
            Swal.fire({
                title: "Are you sure?",
                text: "It will delete your basket?",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Yes, delete it!",
            }).then((result) => {
                if (result.value) {
                    var cartData = JSON.parse(localStorage.getItem("cart"));
                    $.each(cartData.items, function (k21, v22) {
                        if (k21 == datai && v22.id == datav) {
                            cartData.items.splice(k21, 1);
                        }
                    });

                    if (!cartData || !cartData.items.length) {
                        localStorage.clear();
                        emptyCart();
                    } else {
                        localStorage.setItem("cart", JSON.stringify(cartData));
                    }
                    syncCartUpdate(
                        "payments/cart-edit",
                        "route",
                        "The item has been deleted!"
                    );
                }
            });
        };

        $(document).on("click", ".picker__nav--next", function () {
            $("#dodatepicker").addClass("picker__input picker__input--active");
        });

        window.syncCartUpdate = async function (
            urlSegment,
            process = null,
            dataMessage = null
        ) {
            const data = await cartUpdate(urlSegment, process);
            if (dataMessage) cAlert(dataMessage, "success");
            return data;
        };

        window.cartUpdate = function (urlSegment, process) {
            return new Promise((resolve, reject) => {
                var cartData = JSON.parse(localStorage.getItem("cart"));
                var bonusIsTrue = localStorage.getItem("bonus");
                var couponCode = $("#coupon_code").val();
                var deliveryType = $(".delivery-options option:selected").val();
                if (cartData && cartData.items.length) {
                    $.ajax({
                        type: "post",
                        url: window.location.origin + "/" + urlSegment,
                        dataType: "json",
                        data: {
                            cart: cartData.items,
                            bonus: bonusIsTrue,
                            coupon_code: couponCode,
                            delivery_type: deliveryType,
                        },
                        success: function (data) {
                            //ajax isteği gelmeden bonus görünmüyor bu yüzden ajax sonuçlandıktan sonra set edilmesi gerekiyor
                            if (bonusIsTrue == "1") {
                                $("#bonus").attr("checked", true);
                            }

                            let deliveryValue = $(
                                ".delivery-options option[value=delivery]"
                            ).data("data");
                            if (data[8].delivery_price.amount != "0") {
                                $(
                                    ".delivery-options option[value=delivery]"
                                ).html(
                                    deliveryValue +
                                        " (+" +
                                        data[8].delivery_price.formatted +
                                        " Delivery Charge)"
                                );
                            } else {
                                $(
                                    ".delivery-options option[value=delivery]"
                                ).html(deliveryValue);
                            }
                            if (data[4] != "") {
                                var msgArr = '<ul style="list-style: none">';
                                $.each(data[4], function (k1, v1) {
                                    msgArr += "<li>" + v1 + "</li>";
                                });
                                msgArr += "</ul>";
                                systemMsg(msgArr);
                                $(".cart-btn")
                                    .closest("#cart-modal")
                                    .find("input, button, checkbox")
                                    .prop("disabled", false);
                                var cartData = JSON.parse(
                                    localStorage.getItem("cart")
                                );
                                var cartDataNew = cartData.items.filter(
                                    (item) => !data[4][item.id]
                                );
                                cartData.items = cartDataNew;
                                localStorage.setItem(
                                    "cart",
                                    JSON.stringify(cartData)
                                );
                                cart(data);
                                if (!cartData || !cartData.items.length) {
                                    localStorage.clear();
                                    emptyCart();
                                }
                            } else {
                                if (data && data[2].required_amount == 0) {
                                    $(".min-alert").hide();
                                    //asapRenderCount++;
                                    asapRender(
                                        data[3].system_status_now,
                                        false
                                    );
                                } else {
                                    var minAlert =
                                        'You need to add <b style="font-size: 15pt;">' +
                                        data[2].required_amount.formatted +
                                        "</b> item to basket.";
                                    $("div.min-alert")
                                        .find("div.alert")
                                        .html(minAlert);
                                    $(".min-alert").show();
                                    //asapRenderCount++;
                                    asapRender(data[3].system_status_now, true);
                                }

                                if (deliveryType == "delivery") {
                                    if (data[8].free_delivery_need == false) {
                                        $("div.free-delivery").hide();
                                    } else {
                                        var freeDeliveryAlert =
                                            '<div class="alert alert-success" role="alert">Free Delivery</div>';
                                        if (
                                            data[8].free_delivery_need.amount >
                                            0
                                        ) {
                                            freeDeliveryAlert =
                                                '<div class="alert alert-warning" role="alert" style="color:#000000;">You can add <b style="font-size: 15pt;">' +
                                                data[8].free_delivery_need
                                                    .formatted +
                                                "</b> to your cart for free delivery.</div>";
                                        }
                                        $("div.free-delivery").html(
                                            freeDeliveryAlert
                                        );
                                        $("div.free-delivery").show();
                                    }
                                } else if (deliveryType == "collect") {
                                    $("div.free-delivery").hide();
                                }

                                if (
                                    process == "route" &&
                                    urlSegment == "payments/cart-edit"
                                ) {
                                    $("#cart-modal").modal("hide");
                                    cart(data);
                                    return resolve(data);
                                } else if (
                                    process == "data" &&
                                    urlSegment == "payments/cart-edit"
                                ) {
                                    return resolve(data);
                                }
                            }
                        },
                        error: function (data) {
                            console.log(data, "error");
                        },
                    });
                } else {
                    localStorage.clear();
                    $("select.delivery-options").prop("selectedIndex", 0);
                    $(".min-alert").hide();
                    $("div.free-delivery").hide();
                    $(".pre-order-btn").prop("disabled", true);
                }
            });
        };

        $(document).on("click", ".cart-data-get", function () {
            try {
                $(".cart-btn")
                    .closest("#cart-modal")
                    .find("input, button, checkbox")
                    .prop("disabled", false);

                var data = {
                    foodid: $(this).data("id"),
                    foodTitle: $(this).data("title"),
                    foodPrice: $(this).data("price"),
                    foodNewPrice: $(this).data("new-price"),
                    foodDiscountNumber: $(this).data("discount-number"),
                    foodImage: $(this).data("image"),
                    foodDescription: $(this).data("description"),
                    foodExtra: JSON.stringify($(this).data("extra")),
                    foodCatExtra: JSON.stringify($(this).data("cat-extra")),
                    foodCatId: $(this).data("cat-id"),
                    foodCatTitle: $(this).data("cat-title"),
                    foodQty: 1,
                };
                localStorage.setItem(
                    "attrs" + $(this).data("id"),
                    JSON.stringify($(this).data("cat-extra"))
                );
                modalContent(data);
            } catch (err) {
                $(".cart-btn")
                    .closest("#cart-modal")
                    .find("input, button, checkbox")
                    .prop("disabled", false);
            }
        });

        $("#cart-modal").on("hidden.bs.modal", function (e) {
            $(".cart-btn")
                .closest("#cart-modal")
                .find("input, button, checkbox")
                .prop("disabled", false);
            $("#pay-modal")
                .find("input, select, a, textarea")
                .prop("disabled", false);
            $("div.actions ul li")
                .last()
                .find("a")
                .html('<i class="fas fa-lock"></i> Complete Order');
            $("div.actions ul li").first().show();
        });

        $(document).on("click", ".cart-btn", function () {
            try {
                //bonusRender();
                $("div.actions ul li").last().find("a").addClass("disabled");

                $(this)
                    .closest("#cart-modal")
                    .find("input, button, checkbox")
                    .prop("disabled", true);
                var datai = $("input[name=foodid]").data("i");
                var datav = $("input[name=foodid]").data("v");
                var attributes = [];
                var dataCQty = $("input[name=qty]").val();
                var dataCId = $("input[name=foodid]").val();

                var items = [];
                var cartData = JSON.parse(localStorage.getItem("cart"));

                $.each($(".attr-check input:checked"), function (keys, vals) {
                    attributes.push(parseInt(vals.value));
                });

                if (datai == "undefined" && datav == "undefined") {
                    var dats = {
                        id: parseInt(dataCId),
                        qty: parseInt(dataCQty),
                        attributes: attributes,
                    };

                    if (cartData) {
                        cartData.items.push(dats);
                        cartData = localStorage.setItem(
                            "cart",
                            JSON.stringify(cartData)
                        );
                    } else {
                        items = {
                            items: [dats],
                        };
                        cartData = localStorage.setItem(
                            "cart",
                            JSON.stringify(items)
                        );
                    }
                } else {
                    $.each(cartData.items, function (k21, v22) {
                        if (k21 == datai && v22.id == datav) {
                            v22.attributes = attributes;
                            v22.qty = parseInt(dataCQty);
                        }
                    });
                    localStorage.setItem("cart", JSON.stringify(cartData));
                }

                autoSelectDelivery();

                syncCartUpdate(
                    "payments/cart-edit",
                    "route",
                    "Your the choose added to basket"
                );
            } catch (err) {
                $(this)
                    .closest("#cart-modal")
                    .find("input, button, checkbox")
                    .prop("disabled", false);
            }
        });

        window.modalContent = function (data) {
            var modalTitle =
                '<h5 class="modal-title" id="exampleModalCenterTitle" style="word-break: break-all;">' +
                data.foodTitle +
                "<br><small>" +
                data.foodDescription +
                "" +
                "</small></h5>" +
                '<button type="button" class="close" data-dismiss="modal" aria-label="Close">' +
                '<span aria-hidden="true">&times;</span>' +
                "</button>";

            $("#cart-modal .modal-header").html(modalTitle);

            var ifFoodPrice = "";
            if (data.foodDiscountNumber) {
                ifFoodPrice =
                    '<div style="font-size: smaller; text-decoration: line-through; color: lightcoral;">' +
                    data.foodPrice +
                    "</div>" +
                    '<div style="font-size: 20pt;">' +
                    data.foodNewPrice +
                    "</div>";
            } else {
                ifFoodPrice =
                    '<div style="font-size: 20pt;">' +
                    data.foodPrice +
                    "</div>";
            }
            var modalBody =
                '<div class="row w-100 align-items-start">' +
                '<div class="col-sm-4 form-group">' +
                '<label for="exampleInputEmail1">Price<div class="w-100"' +
                'style="height: 1px; background-color: #c6c6c6;"></div></label>' +
                ifFoodPrice +
                '</div><input type="hidden" value="' +
                data.foodid +
                '" name="foodid" data-uuid="' +
                data.foodUuid +
                '" data-i="' +
                data.i +
                '" data-v="' +
                data.v +
                '">' +
                '<div class="col-sm-1"></div>' +
                '<div class="col-sm-7 form-group mb-0">' +
                '<label for="exampleInputEmail1">Quantity' +
                '<div class="w-100" style="height: 1px; background-color: #c6c6c6;"></div>' +
                "</label>" +
                '<div class="cart-counter">' +
                '<span class="cart-minus"><i class="fas fa-minus"></i></span>' +
                '<input type="text" name="qty" value="' +
                data.foodQty +
                '" readonly/>' +
                '<span class="cart-plus"><i class="fas fa-plus"></i></span>' +
                "</div>" +
                "</div>" +
                "</div>";
            var extrasub = "";
            var extra = "";
            var selection_type = "";
            var priceForVa = "";

            var foodCatExtraEach = JSON.parse(data.foodCatExtra);
            if (foodCatExtraEach) {
                $.each(foodCatExtraEach, function (key, value) {
                    //key= kategori
                    selection_type = parseInt(value.selection_type);
                    delete value["selection_type"];
                    extrasub +=
                        '<br><label for="basic-url">' + key + "</label>";
                    if (selection_type === 0) {
                        $.each(value, function (ke, va) {
                            priceForVa = va.price.formatted;
                            extrasub +=
                                '<div class="custom-control custom-radio attr-check">' +
                                '<input type="radio" id="check' +
                                va.feature_id +
                                '" data-value="' +
                                va.feature_value +
                                '" value="' +
                                va.feature_id +
                                '" name="' +
                                key +
                                '" class="custom-control-input">' +
                                '<label class="custom-control-label" for="check' +
                                va.feature_id +
                                '">' +
                                "" +
                                va.feature_value +
                                "</label>" +
                                '<label class="custom-control-label" for="check' +
                                va.feature_id +
                                '">' +
                                "&nbsp;&nbsp;&nbsp;" +
                                priceForVa +
                                "</label>" +
                                "</div>";
                        });
                    } else {
                        $.each(value, function (ke, va) {
                            priceForVa = va.price.formatted;
                            extrasub +=
                                '<div class="custom-control custom-checkbox attr-check">' +
                                '<input type="checkbox" data-value="' +
                                va.feature_value +
                                '" class="custom-control-input" id="check' +
                                va.feature_id +
                                '" value="' +
                                va.feature_id +
                                '">' +
                                '<label class="custom-control-label" for="check' +
                                va.feature_id +
                                '">' +
                                va.feature_value +
                                " </label>" +
                                '<label class="custom-control-label" for="check' +
                                va.feature_id +
                                '">&nbsp;&nbsp;&nbsp;' +
                                priceForVa +
                                " </label>" +
                                "</div>";
                        });
                    }
                });

                if (extrasub) {
                    extra +=
                        '<div class="row w-100">' +
                        '<div class="col-sm-12 form-group">' +
                        '<label for="exampleInputEmail1">Extra Ingredients<div class="w-100"' +
                        'style="height: 1px; background-color: #c6c6c6;"></div></label>' +
                        extrasub +
                        "</div>" +
                        "</div>";
                }
                modalBody += extra;
            } else {
                extra = "";
                modalBody += extra;
            }

            var datai =
                data.i != undefined ? "Update the basket" : "Add to Basket";

            var modalFooter =
                '<button type="button" class="btn btn-secondary cart-close" data-dismiss="modal">Close</button>' +
                '<button type="button" class="btn btn-primary cart-btn">' +
                datai +
                "</button>";

            $("#cart-modal .modal-body").html(modalBody);
            $("#cart-modal .modal-footer").html(modalFooter);
            $("#cart-modal").modal("show");
        };

        window.cart = function (dat) {
            var html = "";
            var htmlSub = "";
            var htmlBonusDiscount = "";
            let htmCouponDiscount = "";
            let htmlDeliveryCharge = "";
            let price = dat[1].formatted;

            if (
                dat[5] &&
                dat[5].discount_amount &&
                dat[5].discount_amount.amount > "0"
            ) {
                htmlBonusDiscount =
                    '<div class="row" style="font-size: 0.8rem;">' +
                    '<div class="col-md-7 col-sm-7 w-50">Bonus Discount</div>' +
                    '<div class="col-md-5 col-sm-5 w-50 d-flex justify-content-end cart-sub-total"> -' +
                    dat[5].discount_amount.formatted +
                    "</div>" +
                    "</div>";
                price = dat[5].new_amount.formatted;
            }

            if (
                dat[6] &&
                dat[6].discount_amount &&
                dat[6].discount_amount.amount > "0"
            ) {
                htmCouponDiscount =
                    '<div class="row" style="font-size: 0.8rem;">' +
                    '<div class="col-md-7 col-sm-7 w-50">Coupon Code Discount</div>' +
                    '<div class="col-md-5 col-sm-5 w-50 d-flex justify-content-end cart-sub-total"> -' +
                    dat[6].discount_amount.formatted +
                    "</div>" +
                    "</div>";
                price = dat[6].new_amount.formatted;
            }

            if (
                $(".delivery-options option:selected").val() == "delivery" &&
                dat[8].delivery_price.amount > 0
            ) {
                htmlDeliveryCharge =
                    '<div class="row" style="font-size: 0.8rem;">' +
                    '<div class="col-md-7 col-sm-7 w-50">Delivery Price</div>' +
                    '<div class="col-md-5 col-sm-5 w-50 d-flex justify-content-end cart-sub-total"> +' +
                    dat[8].delivery_price.formatted +
                    "</div>" +
                    "</div>";
                price = dat[8].cart_total.formatted;
            }

            $.each(dat[0], function (k, v) {
                if (v.new_price) {
                    var custom_new_price = v.new_price.formatted;
                }
                var attrs = JSON.stringify(v.attributes)
                    ? escape(JSON.stringify(v.attributes))
                    : null; //escape
                htmlSub +=
                    '<p class="card-text mb-0 cart-food-name" style="font-size: 10pt;">' +
                    v.title +
                    "&nbsp;(Qty: &nbsp;" +
                    v.qty +
                    ")" +
                    '<a data-rid="' +
                    v.id +
                    '" data-title="' +
                    v.title +
                    '" data-price="' +
                    v.price.formatted +
                    '" data-discount-number="' +
                    v.discount_number +
                    '" data-qty="' +
                    v.qty +
                    '"' +
                    'data-description="' +
                    v.description +
                    '"data-price="' +
                    v.price.formatted +
                    '"data-new-price="' +
                    custom_new_price +
                    '" data-i=' +
                    k +
                    " data-v=" +
                    v.id +
                    " data-cat-extra=" +
                    attrs +
                    ' data-id="' +
                    v.uuid +
                    '" href="javascript:void(0)"' +
                    'style="float: right;" class="cart-edit ml-1"><i class="far fa-edit text-success"></i></a>' +
                    '<a href="javascript:void(0)" class="cart-delete" data-rid="' +
                    v.id +
                    '" data-title="' +
                    v.title +
                    '" data-qty="' +
                    v.qty +
                    '"' +
                    '"data-new-price="' +
                    custom_new_price +
                    '"' +
                    'data-description="' +
                    v.description +
                    '" data-price="' +
                    v.price.formatted +
                    '" data-discount-number="' +
                    v.discount_number +
                    '" data-cat-extra=' +
                    attrs +
                    " data-i=" +
                    k +
                    " data-v=" +
                    v.id +
                    '  data-id="' +
                    v.uuid +
                    '" style="float: right;" class="mr-1"> <i class="fas fa-trash text-danger-custom"></i></a>' +
                    "</p>";
                if (v.attributes) {
                    $.each(v.attributes, function (kkk, vvv) {
                        htmlSub +=
                            '<div style="display: flow-root;">' +
                            '<small style="float: left" class="cart-extra-food-name"><i class="fas fa-plus"></i>' +
                            vvv.attribute +
                            "</small>" +
                            '<small style="float: right" class="cart-extra-food-price">' +
                            vvv.price.formatted +
                            "</small>" +
                            "</div>";
                    });
                }
                htmlSub += "<hr>";
            });
            html =
                '<h5 class="card-title d-flex justify-content-between"><span><i class="fas fa-shopping-basket"></i> Your Basket</span> <span id="basketClear" class="text-danger-custom" style="font-size: 10pt; cursor: pointer;"><i class="fas fa-trash"></i> Clear Basket</span></h5>' +
                htmlSub +
                '<div class="row">' +
                '<div class="col-md-7 col-sm-7 w-50">Sub Total</div>' +
                '<div class="col-md-5 col-sm-5 w-50 d-flex justify-content-end cart-sub-total">' +
                dat[1].formatted +
                "</div>" +
                "</div>" +
                htmlDeliveryCharge +
                htmlBonusDiscount +
                htmCouponDiscount +
                "<hr>" +
                '<div class="row">' +
                '<div class="col-md-7 col-sm-7 w-50" style="font-size: 18pt;">Total</div>' +
                '<div class="col-md-5 col-sm-5 w-50 d-flex justify-content-end cart-total" style="font-size: 18pt;">' +
                "" +
                price +
                "</div>" +
                "</div>";

            $(".card-bonus").show();
            $(".cart").html(html);
            return true;
        };

        window.emptyCart = function () {
            $(".pre-order-btn").prop("disabled", true);
            var cartData = JSON.parse(localStorage.getItem("cart"));
            if (!cartData || !cartData.items.length) {
                var eHeader =
                    '<h5 class="card-title text-center"><i class="fas fa-shopping-basket"></i> Your Basket</h5>' +
                    '<div class="row">' +
                    '<div class="col-md-12 col-sm-12 w-100 d-flex justify-content-center" style="font-size: 11pt;">' +
                    "Your basket is empty</div>" +
                    "</div>";
                $(".cart").html(eHeader);
                $(".card-bonus").hide();
                $(".showCoupon").hide();
                $("#coupon_code").val("");
                $(".showCoupon .col").html("");
                $("#coupon_code").prop("disabled", false);
            }
        };
        $(document).on("click", "#basketClear", function () {
            localStorage.clear();
            requireDeliveryType(false);
            emptyCart();
            $("div.free-delivery").hide();
            $(".min-alert").hide();
        });

        $(document).on("click", ".cart-edit", function () {
            try {
                var attrs = unescape($(this).data("cat-extra")); //unescape
                var allAttributes = localStorage.getItem(
                    "attrs" + $(this).data("rid")
                );
                var data = {
                    foodid: $(this).data("rid"),
                    foodTitle: $(this).data("title"),
                    foodPrice: $(this).data("price"),
                    foodNewPrice: $(this).data("new-price"),
                    foodDiscountNumber: $(this).data("discount-number"),
                    foodImage: $(this).data("image"),
                    foodDescription: $(this).data("description"),
                    foodCatExtra: allAttributes,
                    foodCatId: $(this).data("cat-id"),
                    foodCatTitle: $(this).data("cat-title"),
                    foodUuid: $(this).data("id"),
                    foodQty: $(this).data("qty"),
                    foodSelectedExtra: JSON.stringify(attrs),
                    i: $(this).data("i"),
                    v: $(this).data("v"),
                };
                modalContent(data);
                $.each(JSON.parse(attrs), function (k1, v1) {
                    $(
                        '#cart-modal input[data-value="' + v1.attribute + '"]'
                    ).prop("checked", true);
                });
            } catch (err) {
                console.log(err);
            }
        });

        $(document).on("click", ".cart-delete", function () {
            try {
                var datai = $(this).data("i");
                var datav = $(this).data("v");
                cAlertDlete(datai, datav);
            } catch (err) {
                $('#cart-modal input[data-value="' + v1.attribute + '"]').prop(
                    "checked",
                    false
                );
            }
        });

        $(document).on("click", "#pre-order-btn", (e) => {
            e.preventDefault();
            //buildOpenHours(selectedDate(), 'pay');
            $("#pay-modal")
                .find("input, select, a, textarea")
                .prop("disabled", false);
            $("div.actions ul li")
                .last()
                .find("a")
                .html('<i class="fas fa-lock"></i> Complete Order');
            $("div.actions ul li").first().show();
            if (auth) {
                let delivery_type = $(
                    "select.delivery-options option:selected"
                ).val();
                if (delivery_type == "delivery" || delivery_type == "collect") {
                    requireDeliveryType(false);
                    let data = localStorage.getItem("cart");
                    if (data) {
                        $(".card-bonus").show();
                        syncCartUpdate("payments/cart-edit", "data").then(
                            function (datax) {
                                if (datax.system_status_now != "closed") {
                                    modalInside();
                                    $("#pay-modal-new").modal("show");
                                    payModalFoodsTable(datax);
                                }
                            }
                        );
                    }
                } else {
                    requireDeliveryType(true);
                }
            } else {
                location.href = window.location.origin + "/login";
            }
        });

        $(document).on("change", ".delivery-options", function () {
            couponCodeUpdate();
            if ($(this).val() == "delivery") {
                $(".alert.addresses-alert").hide();

                $("input[name=address_title]").show();

                $("textarea[name=address]").show();

                $(
                    "#pills-tab-payContent .textarea-add-new-address textarea"
                ).prop("disabled", false);
                $("#pills-tab-payContent .addresses-group")
                    .find("a.list-group-item")
                    .removeClass("disabled");

                $(".dodatepicker")
                    .closest(".form-group")
                    .find("label")
                    .html(delivery_value + " Date");
                $(".dotimepicker")
                    .closest(".form-group")
                    .find("label")
                    .html(delivery_value + " Time");
            } else if ($(this).val() == "collect") {
                $(".dodatepicker")
                    .closest(".form-group")
                    .find("label")
                    .html(collect_value + " Date");
                $(".dotimepicker")
                    .closest(".form-group")
                    .find("label")
                    .html(collect_value + " Time");

                $(".alert.addresses-alert").hide();

                $("input[name=address_title]").hide();

                $("textarea[name=address]").hide();

                $(
                    "#pills-tab-payContent .textarea-add-new-address textarea"
                ).prop("disabled", true);
                $("#pills-tab-payContent .addresses-group")
                    .find("a.list-group-item")
                    .addClass("disabled");

                $("button.pay-modal-next")
                    .html("NEXT->")
                    .prop("disabled", false);

                $("#pills-tab-pay li:nth-child(1) a").tab("show");
            }
        });

        $(document).on("change", "#delivery-asap", function () {
            if ($(this).is(":checked")) {
                $("#dotimepicker").prop("readonly", true);
                $("#dotimepicker").closest("div").find("i").hide();

                $("#dodatepicker").prop("readonly", true);
                $("#dodatepicker").closest("div").find("i").hide();
                $(".date-time").hide();
            } else {
                $("#dotimepicker").prop("readonly", false);
                $("#dotimepicker").closest("div").find("i").show();
                $("#dodatepicker").prop("readonly", false);
                $("#dodatepicker").closest("div").find("i").show();
                $(".date-time").show();
            }
        });

        $(document).on("change", ".payment-type", function () {
            if ($(this).val() == "card") {
                $(".form-group.stripe-div").show();
                $("#registeredCards").hide();
                $(".stripe-cash-div").hide();
            } else if ($(this).val() == "register_card") {
                $("#registeredCards").show();
                $(".form-group.stripe-div").hide();
                $(".stripe-cash-div").hide();
            } else {
                $(".form-group.stripe-div").hide();
                $("#registeredCards").hide();
                $(".stripe-cash-div").show();
            }
        });

        window.payModalFoodsTable = function (data) {
            let html = "";
            let deliveryPrice = "";
            let bonusPrice = "";
            let couponPrice = "";
            let price =
                typeof data[1].formatted != "undefined"
                    ? data[1].formatted
                    : 0.0;

            if (
                data[5] &&
                data[5].discount_amount &&
                data[5].discount_amount.amount > "0"
            ) {
                bonusPrice =
                    '<tr class="table-secondary">' +
                    '<td colspan="3">Bonus Discount</td>' +
                    "<td>&nbsp;</td>" +
                    "<td> -" +
                    data[5].discount_amount.formatted +
                    "</td>" +
                    "</tr>";
                price = data[5].new_amount.formatted;
            }

            if (
                data[6] &&
                data[6].discount_amount &&
                data[6].discount_amount.amount > "0"
            ) {
                couponPrice =
                    '<tr class="table-secondary">' +
                    '<td colspan="3">Coupon Code Discount</td>' +
                    "<td>&nbsp;</td>" +
                    "<td> -" +
                    data[6].discount_amount.formatted +
                    "</td>" +
                    "</tr>";
                price = data[6].new_amount.formatted;
            }

            if (
                data[8].delivery_price.amount != "0" &&
                $(".delivery-options").val() == "delivery"
            ) {
                deliveryPrice =
                    '<tr class="table-warning">' +
                    '<td colspan="3">Delivery Charge</td>' +
                    "<td>&nbsp;</td>" +
                    "<td> +" +
                    data[8].delivery_price.formatted +
                    "</td>" +
                    "</tr>";

                price = data[8].cart_total.formatted;
            }

            let subPrice =
                '<tr class="table-info">' +
                '<td colspan="3">Sub Total</td>' +
                "<td>&nbsp;</td>" +
                "<td>" +
                data[1].formatted +
                "</td>" +
                "</tr>";
            $.each(data[0], function (key, value) {
                if (value.discount_number) {
                    var priceForValue = value.new_price.formatted;
                } else {
                    var priceForValue = value.price.formatted;
                }
                let subhtml = "";
                if (value.attributes) {
                    $.each(value.attributes, function (k, v) {
                        subhtml +=
                            '<i class="fas fa-plus"></i>' +
                            v.attribute +
                            " " +
                            v.price.formatted +
                            "<br>";
                    });
                }

                html +=
                    "<tr>" +
                    '<td colspan="3">' +
                    value.title +
                    "<br>" +
                    subhtml +
                    "</td>" +
                    "<td>Qty: " +
                    value.qty +
                    "</td>" +
                    "<td>" +
                    priceForValue +
                    "</td>" +
                    "</tr>";
            });
            html +=
                subPrice +
                deliveryPrice +
                bonusPrice +
                couponPrice +
                '<tr class="table-success">' +
                '<td colspan="3">TOTAL</td>' +
                "<td>&nbsp;</td>" +
                "<td>" +
                price +
                "</td>" +
                "</tr>";
            $(".pay-foods-table").find("tbody").html(html);
        };

        window.postOrder = function (dataForm) {
            var cartD = JSON.parse(localStorage.getItem("cart"));
            if (cartD) {
                var returnArray = {};
                for (var i = 0; i < dataForm.length; i++) {
                    returnArray[dataForm[i]["name"]] = dataForm[i]["value"];
                }
                var d_date = $("#dodatepicker").val();
                var d_time = $("#dotimepicker").val();

                var fullDateTime = d_date + " " + d_time;
                returnArray["phone"] = $("#pay-modal-new .phone")
                    ? $("#pay-modal-new .phone").val()
                    : "";
                returnArray["email"] = $("#pay-modal-new .email")
                    ? $("#pay-modal-new .email").val()
                    : "";
                returnArray["name"] = $("#pay-modal-new .name")
                    ? $("#pay-modal-new .name").val()
                    : "";
                returnArray["order_delivery"] = fullDateTime;
                returnArray["platform"] = "web";
                returnArray["cart"] = cartD.items;
                $("input#delivery-asap").is(":checked")
                    ? (returnArray["asap_check"] = "on")
                    : delete returnArray["asap_check"];
                $("input#saveCard").is(":checked")
                    ? (returnArray["saveCard"] = "on")
                    : delete returnArray["saveCard"];
                $("input#bonus").is(":checked")
                    ? (returnArray["bonus"] = "on")
                    : delete returnArray["bonus"];

                if (returnArray["paymentMethod"] == "card") {
                    try {
                        var card_name =
                            document.getElementById("card_name").value;

                        stripe
                            .createPaymentMethod("card", cardElement, {
                                billing_details: {
                                    name: card_name,
                                },
                            })
                            .then(function (result) {
                                if (result.error) {
                                    var errorElement =
                                        document.getElementById("card-errors");
                                    errorElement.textContent =
                                        result.error.message;
                                    orderCompleteButton("reset");
                                    Swal.fire(
                                        "Oops...",
                                        result.error.message,
                                        "error"
                                    );
                                    return false;
                                } else {
                                    returnArray["stripeToken"] =
                                        result.paymentMethod.id;
                                    ajaxPostOrder(returnArray);
                                }
                            });
                    } catch (error) {
                        console.log(error);
                        resetModal();
                        return false;
                    }
                } else {
                    ajaxPostOrder(returnArray);
                }
            }
        };

        window.ajaxPostOrder = function (data) {
            localStorage.removeItem("delivery-options");
            $.ajax({
                url: window.location.origin + "/payments",
                type: "post",
                data: data,
                dataType: "json",
                success: function (data) {
                    bonusRender();

                    if (data == true) {
                        resetModal();
                        return;
                    }

                    if (data.url) {
                        payIframe(data.url);
                    } else if (data.dateMsg) {
                        swalMSg(data.dateMsg);
                    } else {
                        swalMSg(data);
                    }
                },
                complete: function (data) {
                    orderCompleteButton("reset");

                    $("#coupon_code").prop("disabled", false);
                    $(".showCoupon").hide();
                    $(".showCoupon .col").html("");
                    $("#coupon_code").val("");
                },
            });
        };

        window.resetModal = function () {
            $("#pay-modal-new").find("#special-note").val("");
            $("#pay-modal-new").find("tbody").html("");
            $("#pay-modal-new").find("select").prop("disabled", false);
            $("#pay-modal-new").modal("hide");
            $(".pay-tab-one").removeClass("disabled");
            $(".pay-tab-two").addClass("disabled");
            $(".pay-tab-two").attr("data-pass", 0);
            $(".pay-tab-three").addClass("disabled");
            $(".pay-tab-three").attr("data-pass", 0);
            $(".pay-tab-one").tab("show");
            $(".pay-modal-next").show();
            $(".pay-modal-complete").hide();
            $(".pay-modal-complete").removeClass("disabled");
            counterModal = 1;
            localStorage.clear();
            emptyCart();
            if (typeof cardElement != "undefined") cardElement.clear();
            syncCartUpdate("payments/cart-edit", "route").then(function (data) {
                $("input#delivery-asap").prop("checked", false);
                $("#pay-modal-new")
                    .find("input.card-on-name-input, textarea")
                    .val("");
                $(".payment-type").prop("selectedIndex", 0);
                $(".form-group.stripe-div").hide();
            });
            Swal.fire({
                title: "Success",
                text: "Your order has been successfully received",
                icon: "success",
                confirmButtonColor: "#3085d6",
                confirmButtonText:
                    'Previous orders <i class="fas fa-arrow-right"></i>',
            }).then((result) => {
                if (result.value) {
                    window.location.href =
                        window.location.origin + "/order/previous";
                }
            });

            return true;
        };

        $(document).on("change", "select.delivery-options", function () {
            localStorage.setItem(
                "delivery-type",
                $("select.delivery-options option:selected").val()
            );
        });

        $(document).on("change", "#bonus", function () {
            let delivery_type = $(
                "select.delivery-options option:selected"
            ).val();
            if ($(this).is(":checked")) {
                if (delivery_type == "delivery" || delivery_type == "collect") {
                    requireDeliveryType(false);
                    localStorage.setItem("bonus", 1);
                    cAlert("Your points redeemed", "success");
                } else {
                    $(this).prop("checked", false);
                    requireDeliveryType(true);
                }
            } else {
                $(this).prop("checked", false);
                requireDeliveryType(false);
                localStorage.removeItem("bonus");
            }

            syncCartUpdate("payments/cart-edit", "data").then(function (data) {
                payModalFoodsTable(data);
                cart(data);
            });
        });

        $(document).on("click", "#codeCheckBtn", function () {
            couponCodeUpdate();
        });

        window.bonusRender = function () {
            if (auth) {
                let html = "";
                $.ajax({
                    type: "post",
                    url: window.location.origin + "/bonus-render",
                    data: {
                        data: true,
                    },
                    success: function (data) {
                        if (data.bonus.amount != "0") {
                            html +=
                                '<div class="card-body" style="padding: 1rem;">' +
                                '<h5 class="card-title text-center"> Bonuses</h5>' +
                                '<div class="row">' +
                                '<div class="col-md-12 col-sm-12 w-100 d-flex justify-content-center"' +
                                'style="font-size: 11pt;">' +
                                '<div class="form-group">' +
                                '<div class="custom-control custom-checkbox">' +
                                '<input type="checkbox" class="custom-control-input" id="bonus" name="bonus"' +
                                'data-bonus="' +
                                data.bonusDecimal +
                                '">' +
                                '<label class="custom-control-label" for="bonus">' +
                                data.bonus.formatted +
                                "" +
                                " Redeem reward points?</label>" +
                                "</div>" +
                                "</div>" +
                                "</div>" +
                                "</div>" +
                                "</div>";

                            $(".card-bonus").html(html);

                            var bonus = localStorage.getItem("bonus");
                            if (bonus) {
                                $("#bonus").prop("checked", true);
                            } else {
                                $("#bonus").prop("checked", false);
                            }
                        }
                    },
                    error: function (data) {
                        console.log(data);
                    },
                });
            }
        };

        window.payIframe = function (url) {
            unBlockEl("#pay-modal-new div.modal-dialog");
            $("#pay-modal-new .modal-body").html(
                '<div class="row pt-5 mt-5"><div class="col d-flex justify-content-center text-center"><h4>You are redirected to the payment page. Please wait...</h4></div></div><div class="mb-5 pb-5 text-center d-flex justify-content-center" id="uBlock"></div>'
            );
            blockEl("#uBlock");
            $("#pay-modal-new .modal-footer").remove("");
            localStorage.clear();
            $("input#delivery-asap").prop("checked", false);
            $("form#pills-tab-payContent")
                .find("input.card-on-name-input, textarea")
                .val("");
            $(".payment-type").prop("selectedIndex", 0);
            $(".form-group.stripe-div").hide();
            if (typeof cardElement != "undefined") cardElement.clear();
            window.location.href = url;
        };

        window.couponCodeUpdate = function () {
            let delivery_type = $(
                "select.delivery-options option:selected"
            ).val();

            if ($("input#coupon_code").val() != "") {
                if (delivery_type == "delivery" || delivery_type == "collect") {
                    requireDeliveryType(false);
                    syncCartUpdate("payments/cart-edit", "data").then(
                        (data) => {
                            if (
                                data[6] != null &&
                                data[6].discount_amount != null
                            ) {
                                if (data[6].discount_amount.amount != 0) {
                                    $("#coupon_code").prop("disabled", true);
                                    $(".showCoupon").show();
                                    $(".showCoupon .col").html(
                                        "*Used Coupon Code: " +
                                            $("#coupon_code").val()
                                    );
                                    cAlert(
                                        "Coupon code has been used",
                                        "success"
                                    );
                                } else {
                                    $("#coupon_code").prop("disabled", false);
                                    $(".showCoupon").hide();
                                    $(".showCoupon .col").html("");
                                    $("#coupon_code").val("");
                                    cAlert("Invalid coupon code", "error");
                                }
                            } else {
                                if (data[6] != null) {
                                    cAlert("Invalid coupon code", "error");
                                }
                                $("#coupon_code").prop("disabled", false);
                                $(".showCoupon").hide();
                                $(".showCoupon .col").html("");
                                $("#coupon_code").val("");
                            }
                            payModalFoodsTable(data);
                            cart(data);
                        }
                    );
                } else {
                    requireDeliveryType(true);
                }
            }
        };

        window.requireDeliveryType = function (data = false) {
            if (data) {
                $("html, body").animate(
                    {
                        scrollTop: $("#focus-basket").position().top,
                    },
                    500
                );
                $("select.delivery-options").addClass("is-invalid");
                cAlert("Please select a valid delivery type.", "error");
            } else {
                $("select.delivery-options").removeClass("is-invalid");
            }
        };

        window.asapRender = function (status, boolean) {
            switch (status) {
                case "asap":
                    $(".pre-order-btn")
                        .html("Order Now")
                        .prop("disabled", boolean);
                    $("#delivery-asap").prop("checked", true);
                    $("#delivery-asap").closest("div").show();
                    $("#dotimepicker").closest("div").find("i").hide();
                    $("#dodatepicker").closest("div").find("i").hide();
                    $(".date-time").hide();
                    break;
                case "pre-order":
                    $(".pre-order-btn")
                        .html("Pre-Order")
                        .prop("disabled", boolean);
                    $("#delivery-asap").prop("checked", false);
                    $("#delivery-asap").closest("div").hide();
                    $("#dotimepicker").closest("div").find("i").show();
                    $("#dodatepicker").closest("div").find("i").show();
                    $(".date-time").show();
                    //asapRenderCount = 0;
                    break;
                case "closed":
                    $("#cart-modal").modal("hide");
                    $(".pre-order-btn")
                        .html(
                            "We are currently unable to serve now, please try again on the next working day."
                        )
                        .prop("disabled", true);
                    //asapRenderCount = 0;
                    break;
            }
        };

        $(document).ready(function () {
            bonusRender();

            spinner =
                '<div class="spinner-border text-light" role="status" style="width: 1rem; height: 1rem;">' +
                '<span class="sr-only">Loading...</span>' +
                "</div>";

            /*if ($('.delivery-options').val() != 'delivery' || $('.delivery-options').val() != 'collect') {
            $('#bonus').prop('checked', false);
            requireDeliveryType(false);
            localStorage.removeItem('bonus');
            bonusRender();
        }*/
            syncCartUpdate("payments/cart-edit", "data").then(function (data) {
                payModalFoodsTable(data);
                cart(data);
            });
            emptyCart();

            var deliveryType = localStorage.getItem("delivery-type");
            if (deliveryType != null) {
                if (
                    $(
                        "select.delivery-options option[value='" +
                            deliveryType +
                            "']"
                    ).length
                ) {
                    console.log("-----");
                    $("select.delivery-options")
                        .val(deliveryType)
                        .trigger("change");
                } else {
                    localStorage.removeItem("delivery-type");
                    autoSelectDelivery();
                }
            } else {
                autoSelectDelivery();
            }
        });

        function autoSelectDelivery() {
            if (
                $("select.delivery-options option").length == 2 &&
                $("select.delivery-options").val() == "Choose"
            ) {
                let willSelect = $("select.delivery-options option")[1].value;
                $("select.delivery-options").val(willSelect).trigger("change");
            }
        }
    }
})();
